import React from 'react'
import { useStore } from '../../../Stores/store';
import { Formik } from 'formik';
import { DocumentFormValues } from './DocumentFormValues';
import DocumentUploadWidget from './DocumentUploadWidget';
import { observer } from 'mobx-react-lite';
import './DocumentForm.css';

export default observer(function DocumentForm(){
    const { managementStore, categoryStore } = useStore();
    const { updateDocument, selectedDocument, uploadDocument, documentToBeUploaded, documentToBeUploadedFileName } = managementStore;
    const { categories } = categoryStore;

    const formVals : DocumentFormValues = selectedDocument ?? {
        id: 0,
        file: "",
        title: "",
        categoryId: ""
      }

    const handleSubmit = (values : any) => {
        if((values.id === undefined || values.id === 0) && documentToBeUploaded !== undefined){
            uploadDocument(documentToBeUploaded, values)
        }
        else {
            updateDocument(values)
        }
    }

    const inputClass = "w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500";
    const labelClass = "text-sm font-medium text-gray-700";

    return (
        <div className='p-4'>
            <DocumentUploadWidget />
            <Formik
            initialValues={formVals}
            onSubmit={(values) => handleSubmit(values)}
            enableReinitialize
            >
            {({handleSubmit, handleChange, values}) => (
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <div className={selectedDocument !== undefined ? "hideField" : "flex flex-col gap-1"}>
                    <label htmlFor="file" className={labelClass}>File</label>
                    <input type="text" name="file" id="file" value={documentToBeUploaded !== undefined ? `${documentToBeUploadedFileName} - ready for upload - give it a title` : ""} disabled={true} onChange={handleChange} className={inputClass} />
                </div>
                <div className="flex flex-col gap-1">
                    <label htmlFor="title" className={labelClass}>Title</label>
                    <input type="text" name="title" id="title" value={values.title} onChange={handleChange} className={inputClass} />
                </div>
                <div className="flex flex-col gap-1">
                    <label htmlFor="categoryId" className={labelClass}>Category</label>
                    <select name="categoryId" id="categoryId" value={values.categoryId} onChange={handleChange} className={inputClass}>
                        <option value="">None</option>
                        {categories.map(category => (
                            <option key={`category_${category.id}`} value={category.id}>{category.name}</option>
                        ))}
                    </select>
                </div>
                <input type="hidden" id="id" name="id" value={values.id} />
                <button type="submit" className="w-full mt-2 bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 transition-colors text-sm font-medium cursor-pointer">Upload</button>
            </form>
            )}
        </Formik>
      </div>
    )
});